<template>
  <main>
    <div class="row details-payment spec-style">
      <div class="col-md-12 top-wrapper">
        <TopTemplate>
          <template v-slot:left-element>
            <h3>
              {{ $t("title.noteList") }} <span class="long-number">({{ this.countNote }})</span>
            </h3>
          </template>
          <template v-slot:right-element>
            <div class="d-flex buttons-wrapper">
              <a @click="$router.go(-1)" class="btn btn-outline-primary button" :disabled="loading">
                <i class="arrow left"></i>
                {{ $t("button.retour") }}
              </a>
              <router-link
                :to="{
                  name: 'addNote',
                }"
                class="btn button btn-primary"
              >
                <i class="icon-Add"></i>
                {{ $t("button.addNote") }}
              </router-link>
            </div>
          </template>
        </TopTemplate>

        <div class="class-course">{{ classNameConst }} - {{ period }} - {{ course }}</div>
        <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
          <div class="spinner-border text-info" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-if="!loading && reference">
          <!-- Tabs navs -->
          <div class="table message-list">
            <div class>
              <div class="row">
                <div class="col-md-12 table__wrapper">
                  <b-card no-body v-if="!loading && periods">
                    <div class="back-style">
                      <div class="tab-back">
                        <nav>
                          <div class="nav nav-tabs list-nav-pay" id="nav-tab" role="tablist">
                            <button
                              ref="autoClickButton"
                              class="nav-link testnav borderb-tab-note"
                              id="nav-home-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#nav-home"
                              @click="listNotes(classId, courseId, period.id, index)"
                              type="button"
                              role="tab"
                              aria-controls="nav-home"
                              aria-selected="true"
                              v-for="(period, index) in periods"
                              :key="index"
                              :class="{
                                'active-menu': (initialLoad && period.id == period_id) || (!initialLoad && period.id === periods[0].id && !activeIndex),

                                active: period.period === trimester && activeIndex,
                                active: index === activeIndex,
                              }"
                            >
                              {{ period.period }}
                            </button>
                          </div>
                        </nav>
                      </div>
                    </div>
                    <div class="tab-content" id="nav-tabContent">
                      <div class="tab-pane fade show active">
                        <div v-if="loadNotes" class="card mt-4 text-center d-block pt-4 pb-4">
                          <div class="spinner-border text-info" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div>
                        </div>
                        <div class="table" v-if="!loadNotes && referenceNoteJSON.length === 0">{{ $t("common.emptyNote") }}</div>
                        <div v-else class="table">
                          <div>
                            <div class="row">
                              <div class="table__wrapper table-notes">
                                <table v-if="!loadNotes" class="table__classes">
                                  <thead>
                                    <tr>
                                      <th width="10%"></th>
                                      <template v-if="primarySchool">
                                        <th width="10%" :class="{topHeader: classExam}">
                                          <div class="th-table">{{ $t("common.exam") }}</div>
                                        </th>
                                        <th width="10%" :class="{topHeader: classEval}">
                                          <div class="th-table">{{ $t("common.eval") }}</div>
                                        </th>
                                      </template>
                                      <template v-else>
                                        <th width="10%" :class="{topHeader: classOrl}">
                                          <div class="th-table">{{ $t("common.Orl") }}</div>
                                        </th>
                                        <th width="10%" :class="{topHeader: classTp}">
                                          <div class="th-table">{{ $t("common.TP") }}</div>
                                        </th>
                                        <th width="10%" :class="{topHeader: classEe}">
                                          <div class="th-table">{{ $t("common.EE") }}</div>
                                        </th>

                                        <th width="10%" :class="{topHeader: classDc1}">
                                          <div class="th-table">{{ $t("common.DC1") }}</div>
                                        </th>
                                        <th width="10%" :class="{topHeader: classDc2}">
                                          <div class="th-table">{{ $t("common.DC2") }}</div>
                                        </th>
                                        <th width="10%" :class="{topHeader: classDs}">
                                          <div class="th-table">{{ $t("common.DS") }}</div>
                                        </th>
                                        <th width="10%" :class="{topHeader: classExp}">
                                          <div class="th-table">{{ $t("common.Exp") }}</div>
                                        </th>
                                        <th width="10%" :class="{topHeader: classLctr}">
                                          <div class="th-table">{{ $t("common.Lctr") }}</div>
                                        </th>
                                      </template>
                                    </tr>
                                  </thead>

                                  <tbody>
                                    <tr class="item_class spec-tr-moy">
                                      <td width="10%"><div class="spec-tr-avg td-table">Moyenne classe</div></td>
                                      <template v-if="primarySchool">
                                        <td width="10%" :class="{borderLeftRight: classExam}">
                                          <div class="spec-tr-avg td-table">{{ moy.exam === null ? "_" : moy.exam }}</div>
                                        </td>
                                        <td width="10%" :class="{borderLeftRight: classEval}">
                                          <div class="spec-tr-avg td-table">{{ moy.eval === null ? "_" : moy.eval }}</div>
                                        </td>
                                      </template>
                                      <template v-else>
                                        <td width="10%" :class="{borderLeftRight: classOrl}">
                                          <div class="spec-tr-avg td-table">{{ moy.orl === null ? "_" : moy.orl }}</div>
                                        </td>
                                        <td width="10%" :class="{borderLeftRight: classTp}">
                                          <div class="spec-tr-avg td-table">{{ moy.tp === null ? "_" : moy.tp }}</div>
                                        </td>
                                        <td width="10%" :class="{borderLeftRight: classEe}">
                                          <div class="spec-tr-avg td-table">{{ moy.ee === null ? "_" : moy.ee }}</div>
                                        </td>

                                        <td width="10%" :class="{borderLeftRight: classDc1}">
                                          <div class="spec-tr-avg td-table">{{ moy.dc1 === null ? "_" : moy.dc1 }}</div>
                                        </td>
                                        <td width="10%" :class="{borderLeftRight: classDc2}">
                                          <div class="spec-tr-avg td-table">{{ moy.dc2 === null ? "_" : moy.dc2 }}</div>
                                        </td>
                                        <td width="10%" :class="{borderLeftRight: classDs}">
                                          <div class="spec-tr-avg td-table">{{ moy.ds === null ? "_" : moy.ds }}</div>
                                        </td>
                                        <td width="10%" :class="{borderLeftRight: classExp}">
                                          <div class="spec-tr-avg td-table">{{ moy.exp === null ? "_" : moy.exp }}</div>
                                        </td>
                                        <td width="10%" :class="{borderLeftRight: classLctr}">
                                          <div class="spec-tr-avg td-table">{{ moy.lctr === null ? "_" : moy.lctr }}</div>
                                        </td>
                                      </template>
                                    </tr>
                                    <tr v-for="(note, index) in referenceNoteJSON" :key="note.id" class="item_class">
                                      <td class="sepc-border" width="10%">{{ note.student.first_name }} {{ note.student.last_name }}</td>

                                      <template v-if="primarySchool">
                                        <td width="10%" class="sepc-border" :class="[{borderLeftRight: classExam}, {borderBottom: getLength(index) && classExam}]">
                                          <div class="td-table" :class="{activeMax: note.exam == maxExam, activeMin: note.exam == minExam}">{{ getResult(note.exam) }}</div>
                                        </td>
                                        <td width="10%" class="sepc-border" :class="[{borderLeftRight: classEval}, {borderBottom: getLength(index) && classEval}]">
                                          <div class="td-table" :class="{activeMax: note.eval == maxEval, activeMin: note.eval == minEval}">{{ getResult(note.eval) }}</div>
                                        </td>
                                      </template>
                                      <template v-else>
                                        <td width="10%" class="sepc-border" :class="[{borderLeftRight: classOrl}, {borderBottom: getLength(index) && classOrl}]">
                                          <div class="td-table" :class="{activeMax: note.orl == maxOrl, activeMin: note.orl == minOrl}">{{ getResult(note.orl) }}</div>
                                        </td>
                                        <td width="10%" class="sepc-border" :class="[{borderLeftRight: classTp}, {borderBottom: getLength(index) && classTp}]">
                                          <div class="td-table" :class="{activeMax: note.tp == maxTp, activeMin: note.tp == minTp}">{{ getResult(note.tp) }}</div>
                                        </td>
                                        <td width="10%" class="sepc-border" :class="[{borderLeftRight: classEe}, {borderBottom: getLength(index) && classEe}]">
                                          <div class="td-table" :class="{activeMax: note.ee == maxEe, activeMin: note.ee == minEe}">{{ getResult(note.ee) }}</div>
                                        </td>

                                        <td width="10%" class="sepc-border" :class="[{borderLeftRight: classDc1}, {borderBottom: getLength(index) && classDc1}]">
                                          <div class="td-table" :class="{activeMax: note.dc1 == maxDc1, activeMin: note.dc1 == minDc1}">{{ getResult(note.dc1) }}</div>
                                        </td>
                                        <td width="10%" class="sepc-border" :class="[{borderLeftRight: classDc2}, {borderBottom: getLength(index) && classDc2}]">
                                          <div class="td-table" :class="{activeMax: note.dc2 == maxDc2, activeMin: note.dc2 == minDc2}">{{ getResult(note.dc2) }}</div>
                                        </td>
                                        <td width="10%" class="sepc-border" :class="[{borderLeftRight: classDs}, {borderBottom: getLength(index) && classDs}]">
                                          <div class="td-table" :class="{activeMax: note.ds == maxDs, activeMin: note.ds == minDs}">{{ getResult(note.ds) }}</div>
                                        </td>
                                        <td width="10%" class="sepc-border" :class="[{borderLeftRight: classExp}, {borderBottom: getLength(index) && classExp}]">
                                          <div class="td-table" :class="{activeMax: note.exp == maxExp, activeMin: note.exp == minExp}">{{ getResult(note.exp) }}</div>
                                        </td>
                                        <td width="10%" class="sepc-border" :class="[{borderLeftRight: classLctr}, {borderBottom: getLength(index) && classLctr}]">
                                          <div class="td-table" :class="{activeMax: note.lctr == maxLctr, activeMin: note.lctr == minLctr}">{{ getResult(note.lctr) }}</div>
                                        </td>
                                      </template>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
          <!-- Tabs content -->
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import NoteDetailSubjectService from "../../services/noteDetailSubject";
import moment from "moment";
import {mapGetters} from "vuex";
export default {
  name: "DetailsNote",
  components: {
    TopTemplate,
  },
  data() {
    return {
      initialLoad: true,
      classNameConst: null,
      period: null,
      course: null,

      activeIndex: false,
      referenceId: null,
      reference: {},
      referenceYear: {},
      years: [],
      referenceYearsParent: [],
      referenceYearsParentJSON: [],
      calculSomme: 0,
      tabActive: 0,
      sommeCredit: 0,
      sommeDebit: 0,
      loading: false,
      loadNotes: false,
      yearScolaire: null,
      school_years: [],
      payments: [],
      fullname: "",
      isButtonReady: false,
      params: {
        sort: "created_at",
        order: false,
      },
      moment: null,
      classId: null,
      courseId: null,
      period_id: null,
      thead: [],
      arrHead: [],
      referenceNoteJSON: [],
      moy: {},
      persObject: {},
      className: null,
      courseName: null,

      classCc: false,
      classDc1: false,
      classDc2: false,
      classDs: false,
      classEe: false,
      classExp: false,
      classLctr: false,
      classTp: false,
      classOrl: false,
      classExam: false,
      classEval: false,
      datedata: null,

      maxCc: null,
      maxDc1: null,
      maxDc2: null,
      maxDs: null,
      maxEe: null,
      maxExp: null,
      maxLctr: null,
      maxTp: null,
      maxOrl: null,
      maxExam: null,
      maxEval: null,

      arrcc: [],
      arrdc1: [],
      arrdc2: [],
      arrds: [],
      arree: [],
      arrexp: [],
      arrlctr: [],
      arrtp: [],
      arrorl: [],
      exam: [],
      eval: [],

      minCc: null,
      minDc1: null,
      minDc2: null,
      minDs: null,
      minEe: null,
      minExp: null,
      minLctr: null,
      minTp: null,
      minOrl: null,
      minExam: null,
      minEval: null,

      storedObject: null,
      storedDate: null,
      trimester: null,
      TotalWithoutAbsentdc1: [],
      TotalWithoutAbsentdc2: [],
      TotalWithoutAbsentds: [],
      TotalWithoutAbsentee: [],
      TotalWithoutAbsentexp: [],
      TotalWithoutAbsentlctr: [],
      TotalWithoutAbsentorl: [],
      TotalWithoutAbsenttp: [],
      TotalWithoutAbsentExam: [],
      TotalWithoutAbsentEval: [],
      countNote: null,
      categoryId: null,
    };
  },
  computed: {
    ...mapGetters(["getDataNote", "getDate"]),
    primarySchool() {
      return this.categoryId == 1 || this.categoryId == 4;
    },
  },
  watch: {
    getDataNote(newValue, oldValue) {
      if (newValue) {
        var myObject = newValue;
        this.className = myObject.class_name;
        this.courseName = myObject.course_name;
        this.trimester = myObject.period_name;
        this.persObject = myObject;
        this.classCc = myObject.tdevoir == "cc";
        this.classDc1 = myObject.tdevoir == "dc1";
        this.classDc2 = myObject.tdevoir === "dc2";
        this.classDs = myObject.tdevoir == "ds";
        this.classExp = myObject.tdevoir == "exp";
        this.classEe = myObject.tdevoir == "ee";
        this.classLctr = myObject.tdevoir == "lctr";
        this.classTp = myObject.tdevoir == "tp";
        this.classOrl = myObject.tdevoir == "orl";
        this.classExam = myObject.tdevoir == "exam";
        this.classEval = myObject.tdevoir == "eval";
      }
    },
  },
  created() {
    this.moment = moment;
    // this.referenceId = this.$route.params.id;
    this.classId = this.$route.params.classid;
    this.courseId = this.$route.params.courseid;
    this.period_id = Number(this.$route.params.coursePeriode);
    this.datedata = this.getDate;
    if (localStorage.getItem("ObjectData")) {
      this.storedObject = localStorage.getItem("ObjectData");
    }
    if (localStorage.getItem("dateData")) {
      this.storedDate = localStorage.getItem("dateData");
    }
    if (!this.datedata) {
      if (this.storedDate) {
        var myDate = JSON.parse(this.storedDate);
        this.datedata = myDate;
      }
      if (this.storedObject) {
        var myObject = JSON.parse(this.storedObject);
        this.className = myObject.class_name;
        this.courseName = myObject.course_name;
        this.trimester = myObject.period_name;
        this.persObject = myObject;
        this.classCc = myObject.tdevoir == "cc";
        this.classDc1 = myObject.tdevoir == "dc1";
        this.classDc2 = myObject.tdevoir === "dc2";
        this.classDs = myObject.tdevoir == "ds";
        this.classExp = myObject.tdevoir == "exp";
        this.classEe = myObject.tdevoir == "ee";
        this.classLctr = myObject.tdevoir == "lctr";
        this.classTp = myObject.tdevoir == "tp";
        this.classOrl = myObject.tdevoir == "orl";
        this.classExam = myObject.tdevoir == "exam";
        this.classEval = myObject.tdevoir == "eval";
      }
    }
  },
  mounted() {
    this.getPeriods(true);
    // var storedDate = localStorage.getItem('dateData');
    // if (storedDate !== null) {
    //   this.datedata=JSON.parse(storedDate)
    // }
  },

  methods: {
    numberOfNotes(referenceNoteJSON) {
      const distinctExams = new Set();
      for (const item of referenceNoteJSON) {
        for (const field in item) {
          if (field !== "student") {
            if (item[field] !== null) {
              distinctExams.add(field);
            }
          }
        }
      }

      this.countNote = distinctExams.size;
    },
    formatDate(date) {
      if (!date) return "__";
      moment.locale("fr");
      return moment(date).format("DD-MM-YYYY");
    },

    getLength(index) {
      if (index == this.referenceNoteJSON.length - 1) {
        return true;
      }
    },
    getResult(note) {
      return note === null ? "_" : note == -1 ? "A" : note;
    },
    listNotes(classId, courseId, periodId, index) {
      this.initialLoad = false;
      if (index) this.activeIndex = index;
      this.loadNotes = true;
      this.referenceNoteJSON = [];
      this.arrcc = [];
      this.arrdc1 = [];
      this.arrdc2 = [];
      this.arrds = [];
      this.arree = [];
      this.arrexp = [];
      this.arrlctr = [];
      this.arrorl = [];
      this.arrtp = [];
      this.exam = [];
      this.eval = [];

      NoteDetailSubjectService.getAllnotes(classId, courseId, periodId)
        .then((response) => {
          this.referenceNoteJSON = response.data.data;
          this.numberOfNotes(this.referenceNoteJSON);
          this.classNameConst = response.data.class;
          this.period = response.data.period;
          this.course = response.data.course;
          this.categoryId = response.data.school_category_id;
          let totalcc = 0;
          let totaldc1 = 0;
          let totaldc2 = 0;
          let totalds = 0;
          let totalee = 0;
          let totalexp = 0;
          let totallctr = 0;
          let totalorl = 0;
          let totaltp = 0;
          let totalExam = 0;
          let totalEval = 0;
          let avgcc = 0;
          let avgdc1 = 0;
          let avgdc2 = 0;
          let avgds = 0;
          let avgee = 0;
          let avgexp = 0;
          let avglctr = 0;
          let avgorl = 0;
          let avgtp = 0;
          let avgExam = 0;
          let avgEval = 0;
          this.TotalWithoutAbsentdc1 = [];
          this.TotalWithoutAbsentdc2 = [];
          this.TotalWithoutAbsentds = [];
          this.TotalWithoutAbsentee = [];
          this.TotalWithoutAbsentexp = [];
          this.TotalWithoutAbsentlctr = [];
          this.TotalWithoutAbsentorl = [];
          this.TotalWithoutAbsenttp = [];
          this.TotalWithoutAbsentExam = [];
          this.TotalWithoutAbsentEval = [];

          for (var i = 0; i < this.referenceNoteJSON.length; i++) {
            this.referenceNoteJSON[i].cc === null ? (totalcc = null) : this.referenceNoteJSON[i].cc == -1 ? (totalcc += 0) : (totalcc += this.referenceNoteJSON[i].cc);
            this.referenceNoteJSON[i].dc1 === null ? (totaldc1 = null) : this.referenceNoteJSON[i].dc1 == -1 ? (totaldc1 += 0) : (totaldc1 += this.referenceNoteJSON[i].dc1);
            this.referenceNoteJSON[i].dc2 === null ? (totaldc2 = null) : this.referenceNoteJSON[i].dc2 == -1 ? (totaldc2 += 0) : (totaldc2 += this.referenceNoteJSON[i].dc2);
            this.referenceNoteJSON[i].ds === null ? (totalds = null) : this.referenceNoteJSON[i].ds == -1 ? (totalds += 0) : (totalds += this.referenceNoteJSON[i].ds);
            this.referenceNoteJSON[i].ee === null ? (totalee = null) : this.referenceNoteJSON[i].ee == -1 ? (totalee += 0) : (totalee += this.referenceNoteJSON[i].ee);
            this.referenceNoteJSON[i].exp === null ? (totalexp = null) : this.referenceNoteJSON[i].exp == -1 ? (totalexp += 0) : (totalexp += this.referenceNoteJSON[i].exp);
            this.referenceNoteJSON[i].lctr === null ? (totallctr = null) : this.referenceNoteJSON[i].lctr == -1 ? (totallctr += 0) : (totallctr += this.referenceNoteJSON[i].lctr);
            this.referenceNoteJSON[i].orl === null ? (totalorl = null) : this.referenceNoteJSON[i].orl == -1 ? (totalorl += 0) : (totalorl += this.referenceNoteJSON[i].orl);
            this.referenceNoteJSON[i].tp === null ? (totaltp = null) : this.referenceNoteJSON[i].tp == -1 ? (totaltp += 0) : (totaltp += this.referenceNoteJSON[i].tp);
            this.referenceNoteJSON[i].exam === null ? (totalExam = null) : this.referenceNoteJSON[i].exam == -1 ? (totalExam += 0) : (totalExam += this.referenceNoteJSON[i].exam);
            this.referenceNoteJSON[i].eval === null ? (totalEval = null) : this.referenceNoteJSON[i].eval == -1 ? (totalEval += 0) : (totalEval += this.referenceNoteJSON[i].eval);

            this.referenceNoteJSON[i].cc !== -1 && this.arrcc.push(this.referenceNoteJSON[i].cc);
            this.referenceNoteJSON[i].dc1 !== -1 && this.arrdc1.push(this.referenceNoteJSON[i].dc1);
            this.referenceNoteJSON[i].dc2 !== -1 && this.arrdc2.push(this.referenceNoteJSON[i].dc2);
            this.referenceNoteJSON[i].ds !== -1 && this.arrds.push(this.referenceNoteJSON[i].ds);
            this.referenceNoteJSON[i].ee !== -1 && this.arree.push(this.referenceNoteJSON[i].ee);
            this.referenceNoteJSON[i].exp !== -1 && this.arrexp.push(this.referenceNoteJSON[i].exp);
            this.referenceNoteJSON[i].lctr !== -1 && this.arrlctr.push(this.referenceNoteJSON[i].lctr);
            this.referenceNoteJSON[i].orl !== -1 && this.arrorl.push(this.referenceNoteJSON[i].orl);
            this.referenceNoteJSON[i].tp !== -1 && this.arrtp.push(this.referenceNoteJSON[i].tp);
            this.referenceNoteJSON[i].exam !== -1 && this.exam.push(this.referenceNoteJSON[i].exam);
            this.referenceNoteJSON[i].eval !== -1 && this.eval.push(this.referenceNoteJSON[i].eval);
          }

          this.maxCc = Math.max.apply(Math, this.arrcc);
          this.maxDc1 = Math.max.apply(Math, this.arrdc1);
          this.maxDc2 = Math.max.apply(Math, this.arrdc2);
          this.maxDs = Math.max.apply(Math, this.arrds);
          this.maxEe = Math.max.apply(Math, this.arree);
          this.maxExp = Math.max.apply(Math, this.arrexp);
          this.maxLctr = Math.max.apply(Math, this.arrlctr);
          this.maxTp = Math.max.apply(Math, this.arrtp);
          this.maxOrl = Math.max.apply(Math, this.arrorl);
          this.maxExam = Math.max.apply(Math, this.exam);
          this.maxEval = Math.max.apply(Math, this.eval);

          this.minCc = Math.min.apply(Math, this.arrcc);
          this.minDc1 = Math.min.apply(Math, this.arrdc1);
          this.minDc2 = Math.min.apply(Math, this.arrdc2);
          this.minDs = Math.min.apply(Math, this.arrds);
          this.minEe = Math.min.apply(Math, this.arree);
          this.minExp = Math.min.apply(Math, this.arrexp);
          this.minLctr = Math.min.apply(Math, this.arrlctr);
          this.minTp = Math.min.apply(Math, this.arrtp);
          this.minOrl = Math.min.apply(Math, this.arrorl);
          this.minExam = Math.min.apply(Math, this.exam);
          this.minEval = Math.min.apply(Math, this.eval);

          this.referenceNoteJSON.forEach((el) => {
            if (el.dc1 !== -1) {
              this.TotalWithoutAbsentdc1.push({...el});
            }
          });
          this.referenceNoteJSON.forEach((el) => {
            if (el.dc2 !== -1) {
              this.TotalWithoutAbsentdc2.push({...el});
            }
          });
          this.referenceNoteJSON.forEach((el) => {
            if (el.ds !== -1) {
              this.TotalWithoutAbsentds.push({...el});
            }
          });

          this.referenceNoteJSON.forEach((el) => {
            if (el.ee !== -1) {
              this.TotalWithoutAbsentee.push({...el});
            }
          });
          this.referenceNoteJSON.forEach((el) => {
            if (el.exp !== -1) {
              this.TotalWithoutAbsentexp.push({...el});
            }
          });
          this.referenceNoteJSON.forEach((el) => {
            if (el.lctr !== -1) {
              this.TotalWithoutAbsentlctr.push({...el});
            }
          });
          this.referenceNoteJSON.forEach((el) => {
            if (el.orl !== -1) {
              this.TotalWithoutAbsentorl.push({...el});
            }
          });
          this.referenceNoteJSON.forEach((el) => {
            if (el.tp !== -1) {
              this.TotalWithoutAbsenttp.push({...el});
            }
          });
          this.referenceNoteJSON.forEach((el) => {
            if (el.exam !== -1) {
              this.TotalWithoutAbsentExam.push({...el});
            }
          });
          this.referenceNoteJSON.forEach((el) => {
            if (el.eval !== -1) {
              this.TotalWithoutAbsentEval.push({...el});
            }
          });
          totalcc === null ? (avgcc = null) : (avgcc = (totalcc / this.referenceNoteJSON.length).toFixed(2));
          totaldc1 === null ? (avgdc1 = null) : (avgdc1 = (totaldc1 / this.TotalWithoutAbsentdc1.length).toFixed(2));
          totaldc2 === null ? (avgdc2 = null) : (avgdc2 = (totaldc2 / this.TotalWithoutAbsentdc2.length).toFixed(2));
          totalds === null ? (avgds = null) : (avgds = (totalds / this.TotalWithoutAbsentds.length).toFixed(2));
          totalee === null ? (avgee = null) : (avgee = (totalee / this.TotalWithoutAbsentee.length).toFixed(2));
          totalexp === null ? (avgexp = null) : (avgexp = (totalexp / this.TotalWithoutAbsentexp.length).toFixed(2));
          totallctr === null ? (avglctr = null) : (avglctr = (totallctr / this.TotalWithoutAbsentlctr.length).toFixed(2));
          totalorl === null ? (avgorl = null) : (avgorl = (totalorl / this.TotalWithoutAbsentorl.length).toFixed(2));
          totaltp === null ? (avgtp = null) : (avgtp = (totaltp / this.TotalWithoutAbsenttp.length).toFixed(2));
          totalExam === null ? (avgExam = null) : (avgExam = (totalExam / this.TotalWithoutAbsentExam.length).toFixed(2));
          totalEval === null ? (avgEval = null) : (avgEval = (totalEval / this.TotalWithoutAbsentEval.length).toFixed(2));
          this.moy = {cc: avgcc, dc1: avgdc1, dc2: avgdc2, ds: avgds, ee: avgee, exp: avgexp, lctr: avglctr, orl: avgorl, tp: avgtp, exam: avgExam, eval: avgEval};
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            this.$router.push("/error-404");
          }
        })
        .finally(() => {
          this.loadNotes = false;
        });
    },

    getPeriods(e, type) {
      this.loading = true;
      NoteDetailSubjectService.getAllPeriode(this.classId, this.courseId)
        .then(
          (response) => {
            this.periods = response.data;
            this.periods?.map((el) => {
              if (el.period === this.trimester) {
                this.listNotes(this.classId, this.courseId, el.id);
              }
            });
            if (this.period_id) {
              const index = this.periods.findIndex((period) => period.id == this.period_id);
              if (index !== -1) {
                this.activeIndex = index;
                this.initialLoad = false;
                this.listNotes(this.classId, this.courseId, this.period_id);
              }
            }
            this.listNotes(this.classId, this.courseId, this.periods[0].id);
          },
          (error) => {
            if (error.response && error.response.status === 404) {
              this.$router.push("/error-404");
            }
          }
        )
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss">
.spec-style {
  .activeMax {
    color: #34b9bb;
    font-weight: 700;
  }
  .activeMin {
    color: #f35b19;
    font-weight: 700;
  }
  table {
    @media only screen and (max-width: 1300px) {
      overflow: auto;
    }
    caption-side: bottom;
    border-collapse: inherit;
    border-spacing: 0;
    tbody > tr > td.sepc-border {
      border-bottom: 1px solid #e0e7ed !important;
    }
  }
  .spec-tr-moy {
    border-top: none;
    border-bottom: none;
  }
  .table table th {
    border-bottom: none;
  }
  .spec-tr-avg {
    border-bottom: 3px solid #e0e7ed !important;
    border-top: 3px solid #e0e7ed;
    background: rgb(52 185 187 / 7%);
    font-weight: 700;
    &:first-child {
      color: #377879;
      text-transform: uppercase;
    }
    @media only screen and (max-width: 1300px) {
      font-size: 10px;
      font-weight: 800;
      white-space: nowrap;
    }
  }
  .borderLeftRight {
    border-right: 2px solid #377879;
    border-left: 2px solid #377879;
  }
  .table .table__classes tbody > tr > td.borderBottom {
    border-bottom: 2px solid #377879 !important;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .topHeader {
    border-top: 2px solid #377879;
    border-right: 2px solid #377879;
    border-left: 2px solid #377879;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  .class-course {
    margin-bottom: 39px;
    color: #3d3d3d;
    font-size: 14px;
    font-weight: 500;
  }
  .top-template {
    margin-bottom: -2px;
  }

  .long-number {
    color: #377879;
  }
  .table .table__wrapper {
    padding: 0;
  }
  .table .table__wrapper thead > tr > th {
    text-align: center;
    padding: 0;
    .th-table {
      padding: 13px 13px;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
  }
  .table .table__classes tbody > tr > td {
    text-align: center;
    padding: 0;
    .td-table {
      padding: 13px 13px;
      white-space: nowrap;
      @media only screen and (max-width: 1300px) {
        font-size: 10px;
      }
    }
  }
  .back-style {
    background: #fff;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      bottom: 19px;
      height: 1px;
      background-color: #dedede;
      right: 0;
      left: 0;
      width: 100%;
    }
  }
  .tab-back {
    padding-bottom: 20px;
    margin: auto;
    width: fit-content;

    .list-nav-pay {
      .nav-link.active,
      .active-menu {
        font-weight: 700 !important;
        font-size: 14px !important;
        border: none;
        background: transparent;
        color: #34b9bb !important;
        position: relative;
        padding-left: 0;
        padding-right: 0;
        &::after {
          content: "";
          position: absolute;
          bottom: 0px;
          width: 100%;
          height: 2px;
          background-color: #34b9bb;
          right: 0;
        }
      }
    }
    .list-nav-pay .nav-link {
      font-weight: 700;
      font-size: 14px;
      color: #000;
      border: none;
      padding-left: 0;
      padding-right: 0;
      margin: 0 15px;
      &:hover {
        border: none;
      }
    }
    .list-nav-pay {
      border-bottom: none;
    }
    .table__wrapper {
      display: flex;
      justify-content: center;
    }
  }

  .table.message-list {
    background: none;
  }
  .table__wrapper {
    background: none;
  }
  .table-notes {
    background: #fff;
  }
  .card {
    background: none;
  }
}
</style>
